import { render, staticRenderFns } from "./ReporteGeneral.vue?vue&type=template&id=42f46a67&"
import script from "./ReporteGeneral.vue?vue&type=script&lang=js&"
export * from "./ReporteGeneral.vue?vue&type=script&lang=js&"
import style1 from "./ReporteGeneral.vue?vue&type=style&index=1&id=42f46a67&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports